import * as React from 'react';
import { Check } from 'react-feather';

interface Props {
  className?: string;
  complete: boolean;
}

export const TodoItemCheckbox: React.FC<Props> = ({
  complete,
  className = '',
}) => {
  return (
    <div
      className={`rounded-full flex justify-center items-center w-7 h-7 p-1 border ${
        complete
          ? 'bg-green-500 text-white border-green-500'
          : 'border-grey-500'
      } ${className}`}
    >
      {complete ? <Check /> : null}
    </div>
  );
};
